<template>
  <div
    class="tm-detail-overlay"
    :style="dragStyle"
    @pointermove="ziehenBewegen"
    @pointerup="ziehenEnde"
    @pointercancel="ziehenEnde"
  >
    <div class="tm-sheet-griff" @pointerdown="ziehenStart">
      <div class="tm-sheet-griff-inner"></div>
      <button type="button" class="tm-sheet-griff__schliessen" aria-label="Schließen" @pointerdown.stop @click="$emit('close')">✕</button>
    </div>
    <div class="tm-detail-overlay__kopf">
      <span class="tm-detail-overlay__titel">🏆 Rangliste</span>
    </div>

    <div class="tm-detail-overlay__inhalt tm-detail-overlay__inhalt--einfach" v-scroll-melden>
    <div v-if="rangliste.length === 0" class="tm-state">Derzeit keine Ranking verfügbar.</div>
    <div v-else class="tm-rangliste">
      <div
        v-for="eintrag in rangliste"
        :key="eintrag.registrationID"
        :class="['tm-rangliste-zeile', { 'tm-rangliste-zeile--top3': eintrag.ranking <= 3 }]"
      >
        <span class="tm-rangliste-platz">{{ eintrag.ranking }}</span>
        <span class="tm-rangliste-name">{{ eintrag.lastname + " " + eintrag.firstname }}</span>
        <span class="tm-rangliste-punkte">{{ typeof eintrag.value === 'number' ? eintrag.value.toFixed(1) : eintrag.value }}</span>
      </div>
    </div>
    </div>
  </div>
</template>

<script setup>
import { useSheetDrag } from '../composables/useSheetDrag.js'
import { vScrollMelden } from '../lib/scrollLock.js'

defineProps({
  rangliste: { type: Array, required: true } // [{ platz, name, punkte }, ...]
})
const emit = defineEmits(['close'])

const { ziehenStart, ziehenBewegen, ziehenEnde, dragStyle } = useSheetDrag(() => emit('close'))
</script>